import { createFileRoute } from "@tanstack/react-router";

import { FisioCompletoPage } from "@/components/lps/FisioCompletoPage";

export const Route = createFileRoute("/fisiocompleto-wpp")({
  head: () => ({
    meta: [
      { title: "Projeto Fisio Completo · Atendimento pelo WhatsApp | Fisio em Ortopedia" },
      {
        name: "description",
        content:
          "Fale com o time comercial pelo WhatsApp e tire suas dúvidas sobre o Projeto Fisio Completo.",
      },
      { property: "og:title", content: "Projeto Fisio Completo · Atendimento pelo WhatsApp" },
      { property: "og:description", content: "Fale com o time comercial pelo WhatsApp e tire suas dúvidas sobre o Projeto Fisio Completo." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),

  component: FisioCompletoWppRoute,
});

function FisioCompletoWppRoute() {
  return <FisioCompletoPage mode="wpp" />;
}
